export function getSessionKey(state) {
  return state.sessionKey;
}

export function getRoom(state) {
  return state.room;
}

export function getFormInfo(state) {
  return state.formInfo;
}

export function getSingleDayPrice(state) {
  return state.singleDayPrice;
}
